import { Injectable, OnDestroy, OnInit } from "@angular/core";
// import { DOCUMENT } from "@angular/common";
import { v4 as uuidv4 } from 'uuid';
import { environment } from "environments/environment";
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { Title } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User, UserTypeEnum } from "@biz/_core/user/model/user";
import { AppModule } from "app/app.module";
import { HttpClient } from "@angular/common/http";
import { CoreConfigService } from '@core/services/config.service';
import { CoreConfig } from '@core/types/core-config';
import { UserService } from "@biz/_core/user/user.service";
import moment from "moment";
import { FormBuilder } from "@angular/forms";
import { Topic } from "@biz/SYSADMIN/topic/model/topic";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class Lib implements OnInit, OnDestroy {
   static instance: Lib;
   theUser: User = null;
   public countries: any[];
   public cities: any[];
   public list: Topic[];

   constructor(
      public http: HttpClient,
      public _fb: FormBuilder,
      public modalSvc: NgbModal,
      public router: Router,
      private toastr: ToastrService,
      private sidebar: CoreSidebarService,
      private title: Title,
      public _coreConfigService: CoreConfigService,
      // public userService: UserService,
      // @Inject(DOCUMENT) private _document: any
   ) {
      Lib.instance = this;
      this.http.get<Topic[]>(`${environment.apiUrl}/topic`).subscribe((res: Topic[]) => { this.list = res; });

      var userStr = localStorage.getItem('theUser');
      if (userStr && userStr.length > 10) this.theUser = JSON.parse(userStr);
      this.getAppData();
   }
   ngOnDestroy(): void { }
   ngOnInit() { }

   get isLoggedIn() { return this.theUser && this.theUser?.token?.length > 10; }

   logout() {
      localStorage.removeItem('theUser');
      this.theUser = null;
      AppModule.theUserSubject.next(null);
   }
   setLanguage(language, userService: UserService): void {
      userService.setUserLang(language).subscribe(res => {
         this._coreConfigService.getConfig().subscribe((config: CoreConfig) => {
            config.app.appLanguage = language;
            setTimeout(() => { this._coreConfigService.setConfig(config, { emitEvent: false }); }, 100);
         });
      });
   }
   static today() { return new Date(); }
   today() { return Lib.today(); }
   reloadPage(path?: any) { this.router.navigate(['/'], { skipLocationChange: true }).then(() => this.router.navigate([path ?? location.pathname])); }
   toggleSidebar(key): void { this.sidebar.getSidebarRegistry(key).toggleOpen(); }
   static convert2EnglishCharset(value: string): string {
      if (!value) return value;

      var returnString = value;
      //Convert Characters
      returnString = returnString.replace(/ğ/gi, 'g').replace(/ü/gi, 'u').replace(/ş/gi, 's').replace(/ı/gi, 'i').replace(/i̇/gi, 'i').replace(/ö/gi, 'o').replace(/ç/gi, 'c');
      returnString = returnString.replace(/Ğ/gi, 'G').replace(/Ü/gi, 'U').replace(/Ş/gi, 'S').replace(/İ/gi, 'I').replace(/Ö/gi, 'O').replace(/Ç/gi, 'C');
      return returnString.trim();
   }
   static getUniqueId(): any { return uuidv4().toLowerCase().replaceAll('-', ''); }

   static getImage(imagePath: string): string {
      if (!imagePath) return null;
      imagePath = imagePath.replace(/\\/gi, '--');
      var response = `${environment.apiUrl}/settings/image/${encodeURI(imagePath)}`;
      return response;
   }
   imageUrl(id: number) { return `${environment.apiUrl}/document/image/${id}`; }

   static getImageById(imageId: string): string {
      if (!imageId) return "imaj yok";
      var response = `${environment.apiUrl}/document/image/${imageId}`;
      // console.log('getImageById', response);
      return response;
   }

   getImageByDocumentType(entityName: string, entityId: string, documentType: number): string {
      var response = `${environment.apiUrl}/document/imageByType/${entityName}/${entityId}/${documentType}`;
      return response;
   }

   static replaceHtmlSymbols(s: string) {
      // https://www.htmlsymbols.xyz/unicode
      if (!s) return s;
      return s.replace(/</gi, "").replace(/&/gi, "").replace(/%/gi, "").replace(/#/gi, "");//.replace(/>/gi, "");
   }

   openModal(modalId, color: 'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'danger' | '', size: 'xs' | 'sm' | 'lg' | 'xl' | '') {
      this.modalSvc.open(modalId, { centered: true, size: `${size}`, windowClass: `modal modal-${color}` });
   }

   notify(title, message?, behaviour: 'error' | 'info' | 'warning' | 'success' = 'success') {
      if (behaviour === 'error')
         this.toastr.error(message, title, { toastClass: 'toast ngx-toastr', positionClass: 'toast-bottom-center', closeButton: true });
      if (behaviour === 'info')
         this.toastr.info(message, title, { toastClass: 'toast ngx-toastr', positionClass: 'toast-bottom-center', closeButton: true });
      if (behaviour === 'warning')
         this.toastr.warning(message, title, { toastClass: 'toast ngx-toastr', positionClass: 'toast-bottom-center', closeButton: true });
      if (behaviour === 'success')
         this.toastr.success(message, title, { toastClass: 'toast ngx-toastr', positionClass: 'toast-bottom-center', closeButton: true });
   }
   setPageTitle(title: string) { this.title.setTitle(title); }



   // MATH
   static toFixed(value: number, precision: number): number { return Number(value.toFixed(precision)) }
   static discount(value?: number) {
      if (value)
         return (1 - (value / 100));
      else
         return 1;
   }
   sumOf(items: any[], sumProperty?) { return Lib.sumOf(items, sumProperty); }
   static sumOf(items: any[], sumProperty?): any {
      if (!items || !items.length) { return 0; }
      if (!sumProperty) {
         if (items.length > 1) {
            return items.reduce((a, b) => a + b);
         } else { return items[0]; }

      }
      if (sumProperty) {
         if (items.length > 1) {
            return items.map(i => i[sumProperty] ?? 0).reduce((a, b) => a + b);
         } else { return items[0][sumProperty]; }
      }
   }

   static groupBy1(items: any[], keyGetter): any {
      // using          const grouped = this.groupBy(this.DBData, groupItems => groupItems.Category);
      const map = new Map();
      items?.forEach(item => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) { map.set(key, [item]); } else { collection.push(item); }
      });
      return map;
   }
   abs(value) { return Math.abs(value); }

   // ARRAY
   static groupBy(items: any[], keyProprty): any[] {
      if (keyProprty) {
         return items.reduce(
            (result, item) => ({
               ...result,
               [item[keyProprty]]: [
                  ...(result[item[keyProprty]] || []),
                  item,
               ],
            }),
            {},
         );
      } else {
         return items.reduce(
            (result, item) => ({
               ...result,
               [item]: [
                  ...(result[item] || []),
                  item,
               ],
            }),
            {},
         );
      }
   }
   static distinct(items: any[], keyProperty): any[] {
      if (keyProperty) { return [new Set(items.map(i => i[keyProperty]))]; }
      else { return [new Set(items.map(i => i))]; }
   }
   static sort(arr: any[], property?: string, direction: 'asc' | 'desc' = 'asc'): any[] {
      if (!arr || arr.length < 2) return arr;

      if (!direction || direction === 'asc') { }

      if (!property) {
         const sortedArray = arr.sort((obj1, obj2) => {
            if (!direction || direction === 'asc') {
               if (obj1 > obj2) { return 1; }
               if (obj1 < obj2) { return -1; }
               return 0;
            } else if (!direction || direction === 'desc') {
               if (obj1 < obj2) { return 1; }
               if (obj1 > obj2) { return -1; }
               return 0;
            }
         });
         return sortedArray;
      }

      const sortedArray = arr.sort((obj1, obj2) => {
         if (!direction || direction === 'asc') {
            if (obj1[property] > obj2[property]) { return 1; }
            if (obj1[property] < obj2[property]) { return -1; }
            return 0;
         } else if (!direction || direction === 'desc') {
            if (obj1[property] < obj2[property]) { return 1; }
            if (obj1[property] > obj2[property]) { return -1; }
            return 0;
         }
      });
      return sortedArray;
   }







   /**
    * Encode a string in base-64:
    * @param value 
    * @returns 
    */
   static toBase64(value) { return btoa(escape(value)); }
   /**
    * Decode a base-64 encoded string:
    * @param value base64 encoded string
    * @returns 
    */
   static fromBase64(value) { return unescape(atob(value)); }

   static arr2Tree(arr, parentPropertyName) {
      /*
  https://jsfiddle.net/alexandrupausan/qjxpLhfu/
  var arr = [
          {'id':1 ,'parentid' : 0...},
        ];
  */
      arr = [...arr];
      var tree = [], mappedArr = {}, arrElem, mappedElem;

      for (var i = 0, len = arr.length; i < len; i++) {
         arrElem = arr[i];
         mappedArr[arrElem.id] = arrElem;
         mappedArr[arrElem.id]['children'] = [];
      }


      for (var id in mappedArr) {
         if (mappedArr.hasOwnProperty(id)) {
            mappedElem = mappedArr[id];
            if (mappedElem[parentPropertyName]) {
               mappedArr[mappedElem[parentPropertyName]]['children'].push(mappedElem);
            }
            else
               tree.push(mappedElem);
         }
      }
      return tree;
   }

   get isTenantAdminUser() { return this.theUser?.type === UserTypeEnum.TenantAdmin }
   get isAccountAdminUser() { return this.theUser?.type === UserTypeEnum.AccountAdmin }
   get isSYSTEMADMINUser() { return this.theUser?.type === UserTypeEnum.SYSTEM_ADMIN }
   get isProductionUser() { return this.theUser?.type === UserTypeEnum.Production }
   get isTransferUser() { return this.theUser?.type === UserTypeEnum.Trans }
   get isDealerUser() { return this.theUser?.type === UserTypeEnum.Dealer }
   get isSuperUser() { return this.theUser?.departments?.includes('super'); }
   get isYonetimUser() { return this.theUser?.departments?.includes('yonetim'); }
   get isPaketlemeUser() { return this.theUser?.departments?.includes('paketleme') || this.theUser?.departments?.includes('super'); }
   get isFolyoUser() { return this.theUser?.departments?.includes('folyo') || this.theUser?.departments?.includes('super'); }
   get isSevkiyatUser() { return this.theUser?.departments?.includes('sevkiyat') || this.theUser?.departments?.includes('super'); }

   private getAppData() {
      fetch('/assets/app-data/app-data.json').then(response => response.json()).then((res: any) => {
         // console.log('get app data done', res);

         this.countries = [];
         res.countries.split(';').forEach(e => { this.countries.push({ id: e, name: e, _search: e }); });
         this.cities = [];
         res.cities.forEach(e => { this.cities.push({ id: e, name: e }); });
      });
   }

   convertToIdNameList(list, idProperty, nameProperty): any[] { return list.map(e => ({ id: e[idProperty], name: e[nameProperty] })); }
   listItemName(id) { return this.list?.find(i => i.id === id)?.name; }
   getGroup(group: string) { return this.list?.filter(i => i.g === group); }
   getGroupAsync(group: string): Observable<any> {
      return new Observable(observer => {
         observer.next(this.list?.filter(i => i.g === group).map(i => ({ id: i.id, name: i.name, g: i.g, sg: i.sg })));
         observer.complete();
      });
   }
   yearMonth(date) { return moment(date).format('YYYY/MM'); }
   age(date) {
      var d;
      if (date && typeof date === 'string') d = new Date(date); else d = date;
      var ageDifMs = Date.now() - d.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
   }

   secretName(name: string) {
      var res = '';
      name.replaceAll('i', 'İ').toUpperCase().split(' ').forEach((e) => {
         var secret = "*".repeat(e.length);
         secret = `${e[0]}${secret.substring(0, secret.length - 2)}${e[e.length - 1]}`;
         res += secret + ' ';
      });
      return res;
   }

   isDatePassed(d) { return new Date(d).toISOString() < new Date().toISOString(); }
   maskDateFormat(maskedText: string): string {
      if (!maskedText || maskedText.length < 5) return null;
      var year = maskedText.substring(0, 4);
      var monthInt = Number(maskedText.substring(4));
      if (monthInt > 12) return null;
      return `${year}${monthInt.toString().padStart(2, '0')}`;
   }
   get getTick() {
      var start = new Date("2022-01-01");
      var now = new Date();
      return Number(Number((now.getTime() - start.getTime()) / 10).toFixed(0));
   }






   SayiDonustur(sayi) {
      sayi = String(sayi);
      let sonuc = "";
      let bolum1 = ["", "bir", "iki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz"];
      let bolum2 = ["", "on", "yirmi", "otuz", "kırk", "elli", "altmış", "yetmiş", "seksen", "doksan"];
      let bolum3 = ["", "yüz", "bin", "milyon", "milyar", "trilyon", "katrilyon"];

      let sayi1; //tam kısım
      let sayi2 = ""; // ondalıklı kısım


      sayi = sayi.replace(",", "."); //virgül girilirse noktaya dönüştürülüyor

      if (sayi.indexOf(".") > 0) { // nokta varsa (kuruş)

         sayi1 = sayi.substring(0, sayi.indexOf(".")); // tam kısım
         sayi2 = sayi.substring(sayi.indexOf("."), sayi.length); // ondalıklı kısım

      }
      else {
         sayi1 = sayi; // ondalık yok
      }

      var rk = sayi1.split(""); // rakamlara ayırma

      let son;
      let w = 1; // işlenen basamak
      var sonaekle = 0; // binler on binler yüzbinler vs. için sona bin (milyon,trilyon...) eklenecek mi?
      let kac = rk.length; // kaç rakam var?
      let sonint; // işlenen basamağın rakamsal değeri
      let uclubasamak = 0; // hangi basamakta (birler onlar yüzler gibi)
      let artan = 0;  // binler milyonlar milyarlar gibi artışları yapar
      let gecici;

      if (kac > 0) { // virgül öncesinde rakam var mı?
         for (var i = 0; i < kac; i++) {
            son = rk[kac - 1 - i]; // son karakterden başlayarak çözümleme yapılır.
            sonint = parseInt(son); // işlenen rakam
            if (w == 1) { // birinci basamak bulunuyor
               sonuc = bolum1[sonint] + sonuc;
            }
            else if (w == 2) { // ikinci basamak
               sonuc = bolum2[sonint] + sonuc;
            }
            else if (w == 3) { // 3. basamak
               if (sonint == 1) {
                  sonuc = bolum3[1] + sonuc;
               }
               else if (sonint > 1) {
                  sonuc = bolum1[sonint] + bolum3[1] + sonuc;
               }
               uclubasamak++;
            }
            if (w > 3) {    // 3. basamaktan sonraki işlemler
               if (uclubasamak == 1) {
                  if (sonint > 0) {
                     sonuc = bolum1[sonint] + bolum3[2 + artan] + sonuc;
                     if (artan == 0) { // birbin yazmasını engelle
                        if (kac - 1 == i) { //
                           sonuc = sonuc.replace(bolum1[1] + bolum3[2], bolum3[2]);
                        }
                     }
                     sonaekle = 1; // sona bin eklendi
                  }
                  else {
                     sonaekle = 0;
                  }
                  uclubasamak++;

               }
               else if (uclubasamak == 2) {
                  if (sonint > 0) {
                     if (sonaekle > 0) {
                        sonuc = bolum2[sonint] + sonuc;
                        sonaekle++;
                     }
                     else {
                        sonuc = bolum2[sonint] + bolum3[2 + artan] + sonuc;
                        sonaekle++;
                     }
                  }
                  uclubasamak++;

               } else if (uclubasamak == 3) {
                  if (sonint > 0) {
                     if (sonint == 1) {
                        gecici = bolum3[1];
                     }
                     else {
                        gecici = bolum1[sonint] + bolum3[1];
                     }
                     if (sonaekle == 0) {
                        gecici = gecici + bolum3[2 + artan];
                     }
                     sonuc = gecici + sonuc;
                  }
                  uclubasamak = 1;
                  artan++;
               }

            }
            w++; // işlenen basamak
         }

      }

      return sonuc;
   }
   DecimalSayiDonustur(sayi) {
      const integerPart = Math.floor(sayi);
      const decimalPart = sayi - integerPart;
      // console.log('parts', integerPart, Math.floor(decimalPart * 100));
      return `${this.SayiDonustur(integerPart)} EURO, ${this.SayiDonustur(Math.floor(decimalPart * 100))} CENT`.toUpperCase();
   }

   toPrice(v: number) { return Number(v.toFixed(2)); }
};